<template>
  <section class="section-base form-base form-view-result">
    <div v-if="title" class="section-base__title-box">
      <div class="section-base__title">
        {{ title }}
      </div>
    </div>

    <div class="form-view-result mb-10">
      <div class="row-box">
        <div class="input-raw">
          <TextFieldTooltip
            :value="addStatement.originalStatementExtId"
            label="Номер заявления"
          />
        </div>
      </div>
    </div>

    <div class="form-base__title step-name">Сведения о заявителе</div>

    <Block
      v-if="role === Role.PERSON"
      :data="person"
      :field-group="FieldGroup.PERSON"
    />
    <Block
      v-if="role === Role.ORGANIZATION"
      :data="organization"
      :field-group="FieldGroup.ORGANIZATION"
    />
    <Block
      v-if="role === Role.FOREIGN_ORGANIZATION"
      :data="foreignOrganization"
      :field-group="FieldGroup.FOREIGN_ORGANIZATION"
    />

    <template v-if="trustee">
      <ManualTrustee
        v-if="isManual"
        :role="role"
        :add-statement="addStatement"
        :trustee-info="trusteeInfo"
        :assignee="assignee"
        :fill-type-prop="fillType"
        @send="nextHandler"
      >
        <template #footer="{ next }">
          <slot name="footer" :next="next"></slot>
        </template>
      </ManualTrustee>
      <AddStMrpaTrustee
        v-else
        :role="role"
        :original-statement-id="addStatement.originalStatementId"
        :original-statement-type="addStatement.originalStatementType"
        :trustee-info-prop="trustee"
        @send="nextHandler"
      >
        <template #footer="{ next }">
          <slot name="footer" :next="next"></slot>
        </template>
      </AddStMrpaTrustee>
    </template>

    <slot v-else name="footer" :next="nextHandler"></slot>
  </section>
</template>

<script>
import { RouteText } from '@/router';
import TextFieldTooltip from '@/components/elements/statement/FullStatementView/base/TextFieldTooltip.vue';
import { Role } from '@/utils/dictionaries';
import Block from '@/components/elements/statement/FullStatementView/elements/Block';
import { FieldGroup } from '@/utils/fullStatementView';
import ManualTrustee from './ManualTrustee/ManualTrustee';
import AddStMrpaTrustee from './AddStMrpaTrustee';
import { SubjectFillType } from '@/constants';
import { DocumentType } from '@/types/services';

export default {
  name: 'AddStBaseApplicant',
  props: {
    addStatement: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
    },
  },
  components: {
    Block,
    TextFieldTooltip,
    ManualTrustee,
    AddStMrpaTrustee,
  },
  data() {
    return {
      FieldGroup,
      Role,
      RouteText,
    };
  },
  computed: {
    applicant() {
      return this.addStatement?.applicant;
    },

    person() {
      return this.applicant?.person;
    },

    organization() {
      return this.applicant?.organization;
    },

    foreignOrganization() {
      return this.applicant?.foreignOrganization;
    },

    role() {
      if (this.person) return Role.PERSON;
      if (this.organization) return Role.ORGANIZATION;
      if (this.foreignOrganization) return Role.FOREIGN_ORGANIZATION;

      throw new Error('Заявитель не найден');
    },

    trusteeInfo() {
      return this.applicant[this.role].trusteeInfo;
    },

    assignee() {
      return this.applicant[this.role].assignee;
    },

    trustee() {
      return this.trusteeInfo || this.assignee;
    },

    fillType() {
      if (this.assignee) return SubjectFillType.ASSIGNEE;

      const isMrpaByFile =
        this.trusteeInfo.documents?.authorityDocument?.type ===
        DocumentType.MRP;
      const isMrpaByGuid = Boolean(
        this.trusteeInfo?.baseAuthority?.mrpIssuerInn
      );

      if (isMrpaByFile || isMrpaByGuid) return SubjectFillType.MACHINE;

      return SubjectFillType.MANUAL;
    },

    isManual() {
      return [SubjectFillType.MANUAL, SubjectFillType.ASSIGNEE].includes(
        this.fillType
      );
    },
  },
  methods: {
    async scrollToTop() {
      await this.$vuetify.goTo('#header-target', { duration: 200 });
    },

    async nextHandler(trustee) {
      this.$emit('send', trustee);
    },
  },
};
</script>
